<div class="row">
  <div class="col-xl-12">
    <div class="card rounded shadow-lg">
      <div
        class="card-header headerbg"
        style="border-bottom: 3px solid #d8eff8"
      >
        <h5 class="mb-0">Institution Registration</h5>
      </div>
      <div class="card-body">
        <div class="custom_container">
          <form class="well form-horizontal" [formGroup]="myform">
            <div class="row">
              <div class="col-xl-4">
                <input
                  type="radio"
                  name="institutionType"
                  [checked]="beForm"
                  (change)="getForm('be')"
                />
                Basic Education
              </div>

              <div class="col-xl-4">
                <input
                  type="radio"
                  name="institutionType"
                  [checked]="tvetForm"
                  (change)="getForm('tvetForm')"
                />
                TVET
              </div>

              <div class="col-xl-4">
                <input
                  type="radio"
                  name="institutionType"
                  [checked]="higherForm"
                  (change)="getForm('higherForm')"
                />
                Higher Education
              </div>
            </div>

            <div *ngIf="beForm">
              <div class="container">
                <fieldset class="border rounded-3 p-3">
                  <legend class="float-none w-auto px-3">
                    Institution Details
                  </legend>

                  <div class="row">
                    <!-- Email -->
                    <div class="col-md-6">
                      <div class="form-group row pt-4">
                        <label class="col-md-4 control-label"
                          >Email <span class="text-danger">*</span></label
                        >
                        <div class="col-md-8">
                          <input
                            type="email"
                            class="form-control"
                            formControlName="email"
                            (blur)="validateEmail($event)"
                            (change)="checkEmail($event)"
                          />
                        </div>
                      </div>
                    </div>
                    <!-- Mobile Number -->
                    <div class="col-md-6">
                      <div class="form-group row pt-4">
                        <label class="col-md-4 control-label"
                          >Mobile Number
                          <span class="text-danger">*</span></label
                        >
                        <div class="col-md-8">
                          <input
                            type="text"
                            class="form-control"
                            formControlName="mobileno"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group row pt-4">
                        <label class="col-md-4 control-label line_2 rem_1">
                          Institution Name
                          <span class="text-danger">*</span>
                        </label>
                        <div class="col-md-8 inputGroupContainer">
                          <div class="input-group">
                            <strong>:</strong> &nbsp;
                            <input
                              class="form-control shadow-sm rounded-lg"
                              formControlName="TNT_NAME"
                            />
                          </div>
                          <div *ngIf="myform.get('TNT_NAME').touched">
                            <span
                              class="text-danger"
                              *ngIf="
                                myform.get('TNT_NAME').hasError('required')
                              "
                            >
                              This field is required.
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group row pt-4">
                        <label class="col-md-4 control-label line_2 rem_1">
                          Address
                          <span class="text-danger">*</span>
                        </label>
                        <div class="col-md-8 inputGroupContainer">
                          <div class="input-group">
                            <strong>:</strong> &nbsp;
                            <textarea
                              class="form-control"
                              formControlName="TNT_DESCRIPTION"
                            ></textarea>
                          </div>
                          <div *ngIf="myform.get('TNT_DESCRIPTION').touched">
                            <span
                              class="text-danger"
                              *ngIf="
                                myform
                                  .get('TNT_DESCRIPTION')
                                  .hasError('required')
                              "
                            >
                              This field is required.
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- Landmark -->
                    <div class="col-md-6">
                      <div class="form-group row pt-4">
                        <label class="col-md-4 control-label"
                          >Nearest landmark/town</label
                        >
                        <div class="col-md-8">
                          <input
                            type="text"
                            class="form-control"
                            formControlName="landmark"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group row pt-4">
                        <label class="col-md-4 control-label line_2 rem_1">
                          County
                          <span class="text-danger">*</span>
                        </label>
                        <div class="col-md-8 inputGroupContainer">
                          <div class="input-group">
                            <strong>:</strong> &nbsp;
                            <select
                              class="form-control shadow-sm rounded-lg"
                              formControlName="TNT_CONCURRENT_AVSESSIONS"
                              (change)="subCounties($any($event.target).value)"
                            >
                              <option value="" [selected]="true">select</option>
                              <option
                                *ngFor="let item of County"
                                [value]="item.COUNTIES_CODE"
                              >
                                {{ item.COUNTIES_NAME }}
                              </option>
                            </select>
                          </div>
                          <div
                            *ngIf="
                              myform.get('TNT_CONCURRENT_AVSESSIONS').touched
                            "
                          >
                            <span
                              class="text-danger"
                              *ngIf="
                                myform
                                  .get('TNT_CONCURRENT_AVSESSIONS')
                                  .hasError('required')
                              "
                            >
                              This field is required.
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group row pt-4">
                        <label class="col-md-4 control-label line_2 rem_1">
                          Sub County
                          <span class="text-danger">*</span>
                        </label>
                        <div class="col-md-8 inputGroupContainer">
                          <div class="input-group">
                            <strong>:</strong> &nbsp;
                            <select
                              class="form-control shadow-sm rounded-lg"
                              formControlName="TNT_USERSPERSESSION"
                            >
                              <option value="" [selected]="true">select</option>
                              <option
                                *ngFor="let item of subCounty"
                                [value]="item.sub_counties_id"
                              >
                                {{ item.sub_counties_name }}
                              </option>
                            </select>
                          </div>
                          <div
                            *ngIf="myform.get('TNT_USERSPERSESSION').touched"
                          >
                            <span
                              class="text-danger"
                              *ngIf="
                                myform
                                  .get('TNT_USERSPERSESSION')
                                  .hasError('required')
                              "
                            >
                              This field is required.
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group row pt-4">
                        <label class="col-md-4 control-label line_2 rem_1">
                          Constituency
                        </label>
                        <div class="col-md-8 inputGroupContainer">
                          <div class="input-group">
                            <strong>:</strong> &nbsp;
                            <select
                              class="form-control shadow-sm rounded-lg"
                              formControlName="constituency"
                            >
                              <option value="0">select</option>
                              <option
                                *ngFor="let item of Constituency"
                                [value]="item.con_counties_id"
                              >
                                {{ item.con_counties_name }}
                              </option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- School Reg No -->
                    <div class="col-md-6">
                      <div class="form-group row pt-4">
                        <label class="col-md-4 control-label"
                          >Institution Reg No</label
                        >
                        <div class="col-md-8">
                          <input
                            type="text"
                            class="form-control"
                            formControlName="school_regno"
                          />
                        </div>
                      </div>
                    </div>

                    <!-- School Location -->
                    <div class="col-md-6">
                      <div class="form-group row pt-4">
                        <label class="col-md-4 control-label"
                          >Institution Location</label
                        >
                        <div class="col-md-8">
                          <input
                            type="text"
                            class="form-control"
                            formControlName="schoollocation"
                          />
                        </div>
                      </div>
                    </div>

                    <!-- School Level -->
                    <div class="col-md-6">
                      <div class="form-group row pt-4">
                        <label class="col-md-4 control-label"
                          >Institution Level</label
                        >
                        <div class="col-md-8">
                          <!-- <input
                              type="text"
                              class="form-control"
                              formControlName="schoollevel"
                            /> -->
                          <select
                            class="form-select"
                            formControlName="schoollevel"
                          >
                            <option value="0">Select</option>
                            <option
                              *ngFor="let item of levels"
                              [value]="item.level_id"
                            >
                              {{ item.level_desc }}
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>

                    <!-- School Name on Certificate -->
                    <div class="col-md-6">
                      <div class="form-group row pt-4">
                        <label class="col-md-4 control-label"
                          >Institution Name in Certificate</label
                        >
                        <div class="col-md-8">
                          <input
                            type="text"
                            class="form-control"
                            formControlName="schoolnameincertificate"
                          />
                        </div>
                      </div>
                    </div>

                    <!-- Latitude Co-ordinate -->
                    <div class="col-md-6">
                      <div class="form-group row pt-4">
                        <label class="col-md-4 control-label"
                          >Latitude Co-ordinate</label
                        >
                        <div class="col-md-8">
                          <input
                            type="text"
                            class="form-control"
                            formControlName="latitude"
                          />
                        </div>
                      </div>
                    </div>

                    <!-- Longitude Co-ordinate -->
                    <div class="col-md-6">
                      <div class="form-group row pt-4">
                        <label class="col-md-4 control-label"
                          >Longitude Co-ordinate</label
                        >
                        <div class="col-md-8">
                          <input
                            type="text"
                            class="form-control"
                            formControlName="longitude"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </fieldset>
              </div>

              <div class="container pt-2 d-none">
                <fieldset class="border rounded-3 p-3">
                  <legend class="float-none w-auto px-3">
                    Bank Information
                  </legend>

                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group row pt-4">
                        <label class="col-md-4 control-label">SIMBA ACC</label>
                        <div class="col-md-8">
                          <input
                            type="text"
                            class="form-control"
                            formControlName="simba_acc"
                          />
                        </div>
                      </div>
                    </div>

                    <!-- GPA ACC NO -->
                    <div class="col-md-6">
                      <div class="form-group row pt-4">
                        <label class="col-md-4 control-label">GPA ACC No</label>
                        <div class="col-md-8">
                          <input
                            type="text"
                            class="form-control"
                            formControlName="gpa_accno"
                          />
                        </div>
                      </div>
                    </div>

                    <!-- Bank Branch -->
                    <div class="col-md-6">
                      <div class="form-group row pt-4">
                        <label class="col-md-4 control-label"
                          >Bank Branch</label
                        >
                        <div class="col-md-8">
                          <input
                            type="text"
                            class="form-control"
                            formControlName="bankbranch"
                          />
                        </div>
                      </div>
                    </div>

                    <!-- Bank Name -->
                    <div class="col-md-6">
                      <div class="form-group row pt-4">
                        <label class="col-md-4 control-label">Bank Name</label>
                        <div class="col-md-8">
                          <input
                            type="text"
                            class="form-control"
                            formControlName="bankname"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </fieldset>
              </div>

              <div class="container pt-2">
                <fieldset class="border rounded-3 p-3">
                  <legend class="float-none w-auto px-3">Teaching Staff</legend>

                  <div class="row">
                    <!-- No of Teaching Male -->
                    <div class="col-md-6">
                      <div class="form-group row pt-4">
                        <label class="col-md-4 control-label"
                          >Teaching Male</label
                        >
                        <div class="col-md-8">
                          <input
                            type="number"
                            class="form-control"
                            formControlName="noofteaching_male"
                          />
                        </div>
                      </div>
                    </div>

                    <!-- No of Teaching Female -->
                    <div class="col-md-6">
                      <div class="form-group row pt-4">
                        <label class="col-md-4 control-label"
                          >Teaching Female</label
                        >
                        <div class="col-md-8">
                          <input
                            type="number"
                            class="form-control"
                            formControlName="noofteaching_female"
                          />
                        </div>
                      </div>
                    </div>
                    <!-- No of Total -->
                    <div class="col-md-6">
                      <div class="form-group row pt-4">
                        <label class="col-md-4 control-label">Total</label>
                        <div class="col-md-8">
                          <input
                            type="number"
                            class="form-control"
                            formControlName="noofteaching_total"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </fieldset>
              </div>

              <div class="container pt-2">
                <fieldset class="border rounded-3 p-3">
                  <legend class="float-none w-auto px-3">
                    Non-Teaching Staff
                  </legend>
                  <div class="row">
                    <!-- No of Non Teaching Male -->
                    <div class="col-md-6">
                      <div class="form-group row pt-4">
                        <label class="col-md-4 control-label"
                          >Non-Teaching Male</label
                        >
                        <div class="col-md-8">
                          <input
                            type="number"
                            class="form-control"
                            formControlName="noofnonteaching_male"
                          />
                        </div>
                      </div>
                    </div>

                    <!-- No of Non Teaching Female -->
                    <div class="col-md-6">
                      <div class="form-group row pt-4">
                        <label class="col-md-4 control-label"
                          >Non-Teaching Female</label
                        >
                        <div class="col-md-8">
                          <input
                            type="number"
                            class="form-control"
                            formControlName="noofnonteaching_female"
                          />
                        </div>
                      </div>
                    </div>
                    <!-- No of TOTAL -->
                    <div class="col-md-6">
                      <div class="form-group row pt-4">
                        <label class="col-md-4 control-label">Total</label>
                        <div class="col-md-8">
                          <input
                            type="number"
                            class="form-control"
                            formControlName="noofnonteaching_total"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </fieldset>
              </div>
              <div class="container pt-2">
                <fieldset class="border rounded-3 p-3">
                  <legend class="float-none w-auto px-3">
                    Learner Enrolment
                  </legend>
                  <div class="row">
                    <!-- Enrollment Boys -->
                    <div class="col-md-6">
                      <div class="form-group row pt-4">
                        <label class="col-md-4 control-label"
                          >Enrollment Boys</label
                        >
                        <div class="col-md-8">
                          <input
                            type="number"
                            class="form-control"
                            formControlName="enrollment_boys"
                          />
                        </div>
                      </div>
                    </div>

                    <!-- Enrollment Girls -->
                    <div class="col-md-6">
                      <div class="form-group row pt-4">
                        <label class="col-md-4 control-label"
                          >Enrollment Girls</label
                        >
                        <div class="col-md-8">
                          <input
                            type="number"
                            class="form-control"
                            formControlName="enrollment_girls"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group row pt-4">
                        <label class="col-md-4 control-label">Total</label>
                        <div class="col-md-8">
                          <input
                            type="number"
                            class="form-control"
                            formControlName="learnerenrolment_total"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </fieldset>
              </div>
              <div class="container pt-2">
                <fieldset class="border rounded-3 p-3">
                  <legend class="float-none w-auto px-3">Other Details</legend>
                  <div class="row">
                    <!-- <div class="col-md-6" id="isChecked">
                        <div class="form-group row pt-4">
                          <label class="col-md-4 control-label line_2 rem_1">
                            {{ labelName.IsProctoring }}
                            <span class="text-danger">*</span></label
                          >
                          <div class="col-md-8 inputGroupContainer">
                            <div class="input-group">
                              <strong>:</strong> &nbsp;
                              <input
                                type="checkbox"
                                class="checkbox"
                                formControlName="allow_proctoring"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6" id="isChecked">
                        <div class="form-group row pt-4">
                          <label class="col-md-4 control-label line_2 rem_1">
                            {{ labelName.IsExampad }}
                            <span class="text-danger">*</span></label
                          >
                          <div class="col-md-8 inputGroupContainer">
                            <div class="input-group">
                              <strong>:</strong> &nbsp;
                              <input
                                type="checkbox"
                                class="checkbox"
                                formControlName="allow_exampad"
                              />
                            </div>
                          </div>
                        </div>
                      </div> -->
                    <!-- SIMBA ACC -->

                    <!-- SNE Type -->
                    <div class="col-md-6">
                      <div class="form-group row pt-4">
                        <label class="col-md-4 control-label">SNE Type</label>
                        <div class="col-md-8">
                          <!-- <input
                            type="text"
                            class="form-control"
                            formControlName="snetype"
                          /> -->
                          <select
                            class="form-select"
                            [(ngModel)]="sneType"
                            [ngModelOptions]="{ standalone: true }"
                            name="sneType"
                          >
                            <option value="">Select</option>
                            <option value="true">YES</option>
                            <option value="false">NO</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6" *ngIf="sneType === 'true'">
                      <div class="form-group row pt-4">
                        <label class="col-md-4 control-label"
                          >SNE Details</label
                        >
                        <div class="col-md-8">
                          <select
                            class="form-select"
                            [(ngModel)]="sneDetail"
                            [ngModelOptions]="{ standalone: true }"
                            name="sneDetail"
                          >
                            <option value="">Select</option>
                            <option value="1">Visual Impairment (VI)</option>
                            <option value="2">
                              Physically Handicapped (PH)
                            </option>
                            <option value="3">Hearing Impairment (HI)</option>
                            <option value="4">Other</option>
                          </select>
                        </div>
                      </div>
                    </div>

                    <!-- Show free-text input if 'Other' is selected -->
                    <div class="col-md-6" *ngIf="sneDetail === '4'">
                      <div class="form-group row pt-4">
                        <label class="col-md-4 control-label"
                          >Please Specify</label
                        >
                        <div class="col-md-8">
                          <input
                            type="text"
                            class="form-control"
                            formControlName="sne_disabilitytype_otherdescription"
                            name="sneOther"
                            placeholder="Describe here..."
                          />
                        </div>
                      </div>
                    </div>
                    <!-- Accommodation Type -->
                    <div class="col-md-6">
                      <div class="form-group row pt-4">
                        <label class="col-md-4 control-label"
                          >Accommodation Type</label
                        >
                        <div class="col-md-8">
                          <!-- <input
                              type="text"
                              class="form-control"
                              formControlName="accommodation_type"
                            /> -->
                          <select
                            class="form-select"
                            formControlName="accommodation_type"
                          >
                            <option value="0">Select</option>
                            <option value="1">Day</option>
                            <option value="2">Boarding</option>
                            <option value="3">Hybrid</option>
                          </select>
                        </div>
                      </div>
                    </div>

                    <!-- Gender Parity Index -->
                    <div class="col-md-6">
                      <div class="form-group row pt-4">
                        <label class="col-md-4 control-label"
                          >Gender Parity Index</label
                        >
                        <div class="col-md-8">
                          <input
                            type="text"
                            class="form-control"
                            formControlName="gpi"
                          />
                        </div>
                      </div>
                    </div>

                    <!-- Application Type -->
                    <div class="col-md-6">
                      <div class="form-group row pt-4">
                        <label class="col-md-4 control-label"
                          >Application Type</label
                        >
                        <div class="col-md-8">
                          <select
                            class="form-select"
                            formControlName="applicationtype"
                          >
                            <option value="0">Select</option>
                            <option value="1">Public</option>
                            <option value="2">Private</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                </fieldset>
              </div>
            </div>
            <div *ngIf="higherForm || tvetForm">
              <div class="container">
                <fieldset class="border rounded-3 p-3">
                  <legend class="float-none w-auto px-3">
                    Institution Details
                  </legend>

                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group row pt-4">
                        <label class="col-md-4 control-label line_2 rem_1">
                          Institution Name
                          <span class="text-danger">*</span>
                        </label>
                        <div class="col-md-8 inputGroupContainer">
                          <div class="input-group">
                            <strong>:</strong> &nbsp;
                            <input
                              class="form-control shadow-sm rounded-lg"
                              formControlName="TNT_NAME"
                            />
                          </div>
                          <div *ngIf="myform.get('TNT_NAME').touched">
                            <span
                              class="text-danger"
                              *ngIf="
                                myform.get('TNT_NAME').hasError('required')
                              "
                            >
                              This field is required.
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group row pt-4">
                        <label class="col-md-4 control-label line_2 rem_1">
                          Address
                          <span class="text-danger">*</span>
                        </label>
                        <div class="col-md-8 inputGroupContainer">
                          <div class="input-group">
                            <strong>:</strong> &nbsp;
                            <textarea
                              class="form-control"
                              formControlName="TNT_DESCRIPTION"
                            ></textarea>
                          </div>
                          <div *ngIf="myform.get('TNT_DESCRIPTION').touched">
                            <span
                              class="text-danger"
                              *ngIf="
                                myform
                                  .get('TNT_DESCRIPTION')
                                  .hasError('required')
                              "
                            >
                              This field is required.
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- Landmark -->
                    <div class="col-md-6">
                      <div class="form-group row pt-4">
                        <label class="col-md-4 control-label"
                          >Nearest landmark/town</label
                        >
                        <div class="col-md-8">
                          <input
                            type="text"
                            class="form-control"
                            formControlName="landmark"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group row pt-4">
                        <label class="col-md-4 control-label line_2 rem_1">
                          County
                          <span class="text-danger">*</span>
                        </label>
                        <div class="col-md-8 inputGroupContainer">
                          <div class="input-group">
                            <strong>:</strong> &nbsp;
                            <select
                              class="form-control shadow-sm rounded-lg"
                              formControlName="TNT_CONCURRENT_AVSESSIONS"
                              (change)="subCounties($any($event.target).value)"
                            >
                              <option value="" [selected]="true">select</option>
                              <option
                                *ngFor="let item of County"
                                [value]="item.COUNTIES_CODE"
                              >
                                {{ item.COUNTIES_NAME }}
                              </option>
                            </select>
                          </div>
                          <div
                            *ngIf="
                              myform.get('TNT_CONCURRENT_AVSESSIONS').touched
                            "
                          >
                            <span
                              class="text-danger"
                              *ngIf="
                                myform
                                  .get('TNT_CONCURRENT_AVSESSIONS')
                                  .hasError('required')
                              "
                            >
                              This field is required.
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group row pt-4">
                        <label class="col-md-4 control-label line_2 rem_1">
                          Sub County
                          <span class="text-danger">*</span>
                        </label>
                        <div class="col-md-8 inputGroupContainer">
                          <div class="input-group">
                            <strong>:</strong> &nbsp;
                            <select
                              class="form-control shadow-sm rounded-lg"
                              formControlName="TNT_USERSPERSESSION"
                            >
                              <option value="" [selected]="true">select</option>
                              <option
                                *ngFor="let item of subCounty"
                                [value]="item.sub_counties_id"
                              >
                                {{ item.sub_counties_name }}
                              </option>
                            </select>
                          </div>
                          <div
                            *ngIf="myform.get('TNT_USERSPERSESSION').touched"
                          >
                            <span
                              class="text-danger"
                              *ngIf="
                                myform
                                  .get('TNT_USERSPERSESSION')
                                  .hasError('required')
                              "
                            >
                              This field is required.
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group row pt-4">
                        <label class="col-md-4 control-label line_2 rem_1">
                          Constituency
                        </label>
                        <div class="col-md-8 inputGroupContainer">
                          <div class="input-group">
                            <strong>:</strong> &nbsp;
                            <select
                              class="form-control shadow-sm rounded-lg"
                              formControlName="constituency"
                            >
                              <option value="" [selected]="true">select</option>
                              <option
                                *ngFor="let item of Constituency"
                                [value]="item.con_counties_id"
                              >
                                {{ item.con_counties_name }}
                              </option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- School Reg No -->
                    <div class="col-md-6">
                      <div class="form-group row pt-4">
                        <label class="col-md-4 control-label"
                          >Institution Reg No</label
                        >
                        <div class="col-md-8">
                          <input
                            type="text"
                            class="form-control"
                            formControlName="school_regno"
                          />
                        </div>
                      </div>
                    </div>

                    <!-- School Location -->
                    <div class="col-md-6">
                      <div class="form-group row pt-4">
                        <label class="col-md-4 control-label"
                          >Institution Location</label
                        >
                        <div class="col-md-8">
                          <input
                            type="text"
                            class="form-control"
                            formControlName="schoollocation"
                          />
                        </div>
                      </div>
                    </div>

                    <!-- School Level -->
                    <div class="col-md-6">
                      <div class="form-group row pt-4">
                        <label class="col-md-4 control-label"
                          >Institution Level</label
                        >
                        <div class="col-md-8">
                          <!-- <input
                              type="text"
                              class="form-control"
                              formControlName="schoollevel"
                            /> -->
                          <select
                            class="form-select"
                            formControlName="schoollevel"
                          >
                            <option value="0">Select</option>
                            <option
                              *ngFor="let item of levels"
                              [value]="item.level_id"
                            >
                              {{ item.level_desc }}
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>

                    <!-- School Name on Certificate -->
                    <div class="col-md-6">
                      <div class="form-group row pt-4">
                        <label class="col-md-4 control-label"
                          >Institution Name in Certificate</label
                        >
                        <div class="col-md-8">
                          <input
                            type="text"
                            class="form-control"
                            formControlName="schoolnameincertificate"
                          />
                        </div>
                      </div>
                    </div>

                    <!-- Latitude Co-ordinate -->
                    <div class="col-md-6">
                      <div class="form-group row pt-4">
                        <label class="col-md-4 control-label"
                          >Latitude Co-ordinate</label
                        >
                        <div class="col-md-8">
                          <input
                            type="text"
                            class="form-control"
                            formControlName="latitude"
                          />
                        </div>
                      </div>
                    </div>

                    <!-- Longitude Co-ordinate -->
                    <div class="col-md-6">
                      <div class="form-group row pt-4">
                        <label class="col-md-4 control-label"
                          >Longitude Co-ordinate</label
                        >
                        <div class="col-md-8">
                          <input
                            type="text"
                            class="form-control"
                            formControlName="longitude"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </fieldset>
              </div>

              <div class="container pt-2">
                <fieldset class="border rounded-3 p-3">
                  <legend class="float-none w-auto px-3">
                    Bank Information
                  </legend>

                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group row pt-4">
                        <label class="col-md-4 control-label">SIMBA ACC</label>
                        <div class="col-md-8">
                          <input
                            type="text"
                            class="form-control"
                            formControlName="simba_acc"
                          />
                        </div>
                      </div>
                    </div>

                    <!-- GPA ACC NO -->
                    <div class="col-md-6">
                      <div class="form-group row pt-4">
                        <label class="col-md-4 control-label">GPA ACC No</label>
                        <div class="col-md-8">
                          <input
                            type="text"
                            class="form-control"
                            formControlName="gpa_accno"
                          />
                        </div>
                      </div>
                    </div>

                    <!-- Bank Branch -->
                    <div class="col-md-6">
                      <div class="form-group row pt-4">
                        <label class="col-md-4 control-label"
                          >Bank Branch</label
                        >
                        <div class="col-md-8">
                          <input
                            type="text"
                            class="form-control"
                            formControlName="bankbranch"
                          />
                        </div>
                      </div>
                    </div>

                    <!-- Bank Name -->
                    <div class="col-md-6">
                      <div class="form-group row pt-4">
                        <label class="col-md-4 control-label">Bank Name</label>
                        <div class="col-md-8">
                          <input
                            type="text"
                            class="form-control"
                            formControlName="bankname"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </fieldset>
              </div>
            </div>
          </form>
          <div
            class="text-center pt-4"
            *ngIf="beForm || higherForm || tvetForm"
          >
            <button
              type="button"
              class="btn btn-save"
              data-bs-target="#myModal"
              data-bs-toggle="modal"
              [disabled]="myform.invalid"
              (click)="openPreviewModal()"
            >
              Preview
            </button>
            &nbsp;
            <button
              type="button"
              *ngIf="!isEdit"
              class="btn btn-save"
              (click)="onSubmit(myform)"
              [disabled]="myform.invalid"
            >
              Save
            </button>
            <button
              type="button"
              *ngIf="isEdit"
              class="btn btn-save"
              (click)="onSubmit(myform)"
              [disabled]="myform.invalid"
            >
              Update
            </button>
            &nbsp;
            <button
              type="button"
              class="btn btn-danger"
              id="md_close"
              (click)="close()"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="beForm">
  <div class="modal" tabindex="-1" id="myModal">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Institution Registration Details</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <div class="container">
            <fieldset class="border rounded-3 p-3">
              <legend class="float-none w-auto px-3">
                Institution Details
              </legend>
              <div class="row mb-2">
                <div class="col-md-6">
                  <strong>Email</strong> :
                  {{ userDetails?.email }}
                </div>
                <div class="col-md-6">
                  <strong>Mobile Number</strong> :
                  {{ userDetails?.mobileno }}
                </div>
              </div>
              <div class="row mb-2">
                <div class="col-md-6">
                  <strong>Institution Name</strong> :
                  {{ userDetails?.TNT_NAME }}
                </div>
                <div class="col-md-6">
                  <strong>Address</strong> :
                  {{ userDetails?.TNT_DESCRIPTION }}
                </div>
              </div>
              <div class="row mb-2">
                <div class="col-md-6">
                  <strong>Nearest landmark/town</strong> :
                  {{ userDetails?.landmark }}
                </div>
                <div class="col-md-6">
                  <strong>County</strong> :
                  {{ getCountyList(userDetails?.TNT_CONCURRENT_AVSESSIONS) }}
                </div>
              </div>
              <div class="row mb-2">
                <div class="col-md-6">
                  <strong>Sub County</strong> :
                  {{ getSubCountiesList(userDetails?.TNT_USERSPERSESSION) }}
                </div>
                <div class="col-md-6">
                  <strong>Constituency</strong> :
                  {{ getConstituencyList(userDetails?.constituency) }}
                </div>
              </div>
              <div class="row mb-2">
                <div class="col-md-6">
                  <strong>Institution Reg No</strong> :
                  {{ userDetails?.school_regno }}
                </div>
                <div class="col-md-6">
                  <strong>Institution Location</strong> :
                  {{ userDetails?.schoollocation }}
                </div>
              </div>
              <div class="row mb-2">
                <div class="col-md-6">
                  <strong>Institution Level</strong> :
                  {{ getLevelDescription(userDetails?.schoollevel) }}
                </div>
                <div class="col-md-6">
                  <strong>Institution Name in Certificate</strong> :
                  {{ userDetails?.schoolnameincertificate }}
                </div>
              </div>
              <div class="row mb-2">
                <div class="col-md-6">
                  <strong>Latitude Co-ordinate</strong> :
                  {{ userDetails?.latitude }}
                </div>
                <div class="col-md-6">
                  <strong>Longitude Co-ordinate</strong> :
                  {{ userDetails?.longitude }}
                </div>
              </div>
            </fieldset>
          </div>

          <div class="container pt-2 d-none">
            <fieldset class="border rounded-3 p-3">
              <legend class="float-none w-auto px-3">Bank Information</legend>
              <div class="row mb-2">
                <div class="col-md-6">
                  <strong>SIMBA ACC</strong> :
                  {{ userDetails?.simba_acc }}
                </div>
                <div class="col-md-6">
                  <strong>GPA ACC No</strong> :
                  {{ userDetails?.gpa_accno }}
                </div>
              </div>
              <div class="row mb-2">
                <div class="col-md-6">
                  <strong>Bank Name</strong> :
                  {{ userDetails?.bankname }}
                </div>
                <div class="col-md-6">
                  <strong>Bank Branch</strong> :
                  {{ userDetails?.bankbranch }}
                </div>
              </div>
            </fieldset>
          </div>

          <div class="container pt-2">
            <fieldset class="border rounded-3 p-3">
              <legend class="float-none w-auto px-3">Teaching Staff</legend>
              <div class="row mb-2">
                <div class="col-md-6">
                  <strong>Teaching Male</strong> :
                  {{ userDetails?.noofteaching_male }}
                </div>
                <div class="col-md-6">
                  <strong>Teaching Female</strong> :
                  {{ userDetails?.noofteaching_female }}
                </div>
                <div class="col-md-6">
                  <strong>Total</strong> :
                  {{ userDetails?.noofteaching_total }}
                </div>
              </div>
            </fieldset>
          </div>

          <div class="container pt-2">
            <fieldset class="border rounded-3 p-3">
              <legend class="float-none w-auto px-3">Non-Teaching Staff</legend>
              <div class="row mb-2">
                <div class="col-md-6">
                  <strong>Non-Teaching male</strong> :
                  {{ userDetails?.noofnonteaching_male }}
                </div>
                <div class="col-md-6">
                  <strong>Non-Teaching Female</strong> :
                  {{ userDetails?.noofnonteaching_female }}
                </div>
                <div class="col-md-6">
                  <strong>Total</strong> :
                  {{ userDetails?.noofnonteaching_total }}
                </div>
              </div>
            </fieldset>
          </div>

          <div class="container pt-2">
            <fieldset class="border rounded-3 p-3">
              <legend class="float-none w-auto px-3">Learner Enrolment</legend>

              <div class="row mb-2">
                <div class="col-md-6">
                  <strong>Enrollment Boys</strong> :
                  {{ userDetails?.enrollment_boys }}
                </div>
                <div class="col-md-6">
                  <strong>Enrollment Girls</strong> :
                  {{ userDetails?.enrollment_girls }}
                </div>
                <div class="col-md-6">
                  <strong>Total</strong> :
                  {{ userDetails?.learnerenrolment_total }}
                </div>
              </div>
            </fieldset>
          </div>
          <div class="container pt-2">
            <fieldset class="border rounded-3 p-3">
              <legend class="float-none w-auto px-3">Other Details</legend>

              <div class="row mb-2">
                <div class="col-md-6">
                  <strong>SNE Type</strong> :
                  {{ userDetails?.sne_disability_status ? "YES" : "NO" }}
                </div>
                <div
                  class="col-md-6"
                  *ngIf="userDetails?.sne_disability_status"
                >
                  <strong>SNE Details</strong> :
                  {{
                    userDetails?.sne_disability_type == 1
                      ? "Visual Impairment (VI)"
                      : userDetails?.sne_disability_type == 2
                      ? "Physically Handicapped (PH)"
                      : sne_disability_type == 3
                      ? "Hearing Impairment (HI)"
                      : "Other"
                  }}
                </div>
                <div
                  class="col-md-6"
                  *ngIf="userDetails?.sne_disability_type == 4"
                >
                  <strong>SNE Details</strong> :
                  {{ userDetails?.sne_disabilitytype_otherdescription }}
                </div>
                <div class="col-md-6">
                  <strong>Accommodation Type</strong> :
                  {{
                    userDetails?.accommodation_type == 1
                      ? "Day"
                      : userDetails?.accommodation_type == 2
                      ? "Boarding"
                      : userDetails?.accommodation_type == 3
                      ? "Hybrid"
                      : ""
                  }}
                </div>
              </div>
              <div class="row mb-2">
                <div class="col-md-6">
                  <strong>Email</strong> :
                  {{ userDetails?.email }}
                </div>
                <div class="col-md-6">
                  <strong>Mobile Number</strong> :
                  {{ userDetails?.mobileno }}
                </div>
              </div>
              <div class="row mb-2">
                <div class="col-md-6">
                  <strong>Gender Parity Index</strong> :
                  {{ userDetails?.gpi }}
                </div>
                <div class="col-md-6">
                  <strong>Application Type</strong> :
                  {{
                    userDetails?.applicationtype == 1
                      ? "Public"
                      : userDetails?.applicationtype == 2
                      ? "Private"
                      : ""
                  }}
                </div>
              </div>
            </fieldset>
          </div>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-danger" data-bs-dismiss="modal">
            Close
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="higherForm || tvetForm">
  <div class="modal" tabindex="-1" id="myModal">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Institution Registration Details</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <div class="container">
            <fieldset class="border rounded-3 p-3">
              <legend class="float-none w-auto px-3">
                Institution Details
              </legend>
              <div class="row mb-2">
                <div class="col-md-6">
                  <strong>Institution Name</strong> :
                  {{ userDetails?.TNT_NAME }}
                </div>
                <div class="col-md-6">
                  <strong>Address</strong> :
                  {{ userDetails?.TNT_DESCRIPTION }}
                </div>
              </div>
              <div class="row mb-2">
                <div class="col-md-6">
                  <strong>Nearest landmark/town</strong> :
                  {{ userDetails?.landmark }}
                </div>
                <div class="col-md-6">
                  <strong>County</strong> :
                  {{ getCountyList(userDetails?.TNT_CONCURRENT_AVSESSIONS) }}
                </div>
              </div>
              <div class="row mb-2">
                <div class="col-md-6">
                  <strong>Sub County</strong> :
                  {{ getSubCountiesList(userDetails?.TNT_USERSPERSESSION) }}
                </div>
                <div class="col-md-6">
                  <strong>Constituency</strong> :
                  {{ getConstituencyList(userDetails?.constituency) }}
                </div>
              </div>
              <div class="row mb-2">
                <div class="col-md-6">
                  <strong>Institution Reg No</strong> :
                  {{ userDetails?.school_regno }}
                </div>
                <div class="col-md-6">
                  <strong>Institution Location</strong> :
                  {{ userDetails?.schoollocation }}
                </div>
              </div>
              <div class="row mb-2">
                <div class="col-md-6">
                  <strong>Institution Level</strong> :
                  {{ getLevelDescription(userDetails?.schoollevel) }}
                </div>
                <div class="col-md-6">
                  <strong>Institution Name in Certificate</strong> :
                  {{ userDetails?.schoolnameincertificate }}
                </div>
              </div>
              <div class="row mb-2">
                <div class="col-md-6">
                  <strong>Latitude Co-ordinate</strong> :
                  {{ userDetails?.latitude }}
                </div>
                <div class="col-md-6">
                  <strong>Longitude Co-ordinate</strong> :
                  {{ userDetails?.longitude }}
                </div>
              </div>
            </fieldset>
          </div>

          <div class="container pt-2 d-none">
            <fieldset class="border rounded-3 p-3">
              <legend class="float-none w-auto px-3">Bank Information</legend>
              <div class="row mb-2">
                <div class="col-md-6">
                  <strong>SIMBA ACC</strong> :
                  {{ userDetails?.simba_acc }}
                </div>
                <div class="col-md-6">
                  <strong>GPA ACC No</strong> :
                  {{ userDetails?.gpa_accno }}
                </div>
              </div>
              <div class="row mb-2">
                <div class="col-md-6">
                  <strong>Bank Name</strong> :
                  {{ userDetails?.bankname }}
                </div>
                <div class="col-md-6">
                  <strong>Bank Branch</strong> :
                  {{ userDetails?.bankbranch }}
                </div>
              </div>
            </fieldset>
          </div>

          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-danger"
              data-bs-dismiss="modal"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
